// import ReactDOM from "react-dom/client";
import ReactDOM from "react-dom";
import axios from 'axios';
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'antd/dist/reset.css'
// import './components/cram_school/css/TableTitle.css'
import './styles/globals.css'
import Demosite from './websites/Demosite';
// import UpgradeGrade from "./components/cram_school/UpgradeGrade";
// import App from 'ot'

// axios.defaults.baseURL = "";
// axios.defaults.baseURL = "http://172.0.6.2:8082";
// axios.defaults.baseURL = "https://api-sungolds.orange-technic.com";
// axios.defaults.baseURL = "https://api-pccu.orange-technic.com";
// axios.defaults.baseURL = "https://api-chci.orange-technic.com:8106";
// axios.defaults.baseURL = "https://api-usr-market.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-keytravel.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-donate.nknu.edu.tw";
// axios.defaults.baseURL = "https://test-api-donate.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-commercial.orange-technic.com";`
// axios.defaults.baseURL = "http://140.127.56.21:8082";
// axios.defaults.baseURL = "http://192.168.11.125:8082";
// axios.defaults.baseURL = "http://10.0.1.174:8082";
// axios.defaults.baseURL = "https://api-afats.orange-technic.com";
// axios.defaults.baseURL = "https://api-official.charts.kh.edu.tw";
// axios.defaults.baseURL = "http://library.nknu.edu.tw:1661";
// axios.defaults.baseURL = "https://api-library.nknu.edu.tw";
// axios.defaults.baseURL = "https://test-api-ntust.orange-technic.com";
// axios.defaults.baseURL = "https://test-api-rocafa.orange-technic.com";
// axios.defaults.baseURL = "https://api-rocafa.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-rocafa.orange-technic.com";
// axios.defaults.baseURL = "https://test-api-rocafa.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-yi-cheng-tang.nknu.edu.tw";
// axios.defaults.baseURL = "https://test-api-yi-cheng-tang.nknu.edu.tw";
// axios.defaults.baseURL = "http://localhost:8082";
// axios.defaults.baseURLOtCloud = "http://localhost:8083";
// axios.defaults.baseURLOtCloud = "";
// axios.defaults.baseURL = "https://api-donate.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-education.orange-technic.com";
// axios.defaults.baseURL = "https://www.orange-technic.com:5021";
// axios.defaults.baseURL = "https://www.orange-technic.com:7443";
// axios.defaults.baseURL = "https://www.orange-technic.com:7469";
// axios.defaults.baseURL = "https://www.orange-technic.com:7497";
// axios.defaults.baseURL = "https://www.orange-technic.com:7492";
// axios.defaults.baseURL = "https://www.orange-technic.com:7483";
// axios.defaults.baseURL = "https://www.orange-technic.com:7501";
// axios.defaults.baseURL = "https://www.orange-technic.com:7505";
// axios.defaults.baseURL = "https://www.orange-technic.com:7517";
// axios.defaults.baseURL = "https://www.orange-technic.com:7522";
// axios.defaults.baseURL = "https://www.orange-technic.com:7526";
// axios.defaults.baseURL = "https://www.orange-technic.com:7530";
// axios.defaults.baseURL = "https://www.orange-technic.com:7534";
// axios.defaults.baseURL = "https://test-api-preschool.orange-technic.com";
// axios.defaults.baseURL = "https://api-preschool-admin.orange-technic.com";
// axios.defaults.baseURL = "https://preschool-admin.orange-technic.com:6454";
// axios.defaults.baseURL = "https://demosite-preschool-admin.orange-technic.com:6454";
// axios.defaults.baseURL = "https://yuankuan.orange-technic.com:8101";
// axios.defaults.baseURL = "https://api-hecheng.orange-technic.com";
// axios.defaults.baseURL = "https://api-learningmath.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-chung-hwa.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-pilot.orange-technic.com";
// axios.defaults.baseURL = "https://libappapi.pccu.edu.tw";
// axios.defaults.baseURL = "https://api-iteach.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-mj.orange-technic.com";
// axios.defaults.baseURL = "https://api-empathy.orange-technic.com";
// axios.defaults.baseURL = "https://api-peace-pcc.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-hakka_culture_exam.orange-technic.com";
// axios.defaults.baseURL = "https://test-api-hakka_culture_exam.orange-technic.com";
// axios.defaults.baseURL = "https://test-api-chung-hwa.orange-technic.com";
// axios.defaults.baseURL = "https://test-api-mj.orange-technic.com";
// axios.defaults.baseURL = "https://test-api-mercyenglishcenter.orange-technic.com";
// axios.defaults.baseURL = "https://beta-api-mercyenglishcenter.orange-technic.com";
// axios.defaults.baseURL = "https://test-api-learningmath.orange-technic.com";
// axios.defaults.baseURL = "https://api-usr-market.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-question-bank.nknu.edu.tw";
// axios.defaults.baseURL = "https://test-api-taiwan-gist-admin.nknu.edu.tw";
// axios.defaults.baseURL = "https://api-yi-cheng-tang.nknu.edu.tw";
// axios.defaults.baseURL = "https://test-api-reservation-library.nknu.edu.tw";

// axios.defaults.baseURL = "https://api-queue-management-admin.nknu.edu.tw";
// axios.defaults.baseURL = "https://heyu-inventory-api.orange-technic.com"; // 和裕糧食行正式機
// axios.defaults.baseURL = "https://test-heyu-inventory-api.orange-technic.com"; // 和裕糧食行測試機
// axios.defaults.baseURL = "https://api-rocafa-test-iread-library.nknu.edu.tw"; // 空軍官校測試機
// axios.defaults.baseURL = "https://aio-api-ai.nknu.edu.tw"; // NKNU AIO AI平台
// axios.defaults.baseURL = "https://api-afats.nknu.edu.tw"; // 航空技術學院圖書自動化正式機
// axios.defaults.baseURL = "https://test-api-afats.nknu.edu.tw"; // 航空技術學院圖書自動化測試機
// axios.defaults.baseURL = "https://test-api-library.nknu.edu.tw"; // NKNU圖書自動化測試機
// axios.defaults.baseURL = "https://api-tiande.nknu.edu.tw"; // 天德教正式機
// axios.defaults.baseURL = "https://api-lingxuan.nknu.edu.tw"; // 三教正式機
// axios.defaults.baseURL = "https://api-fengshan-zhennangong.nknu.edu.tw"; // 鳳山鎮南宮仙公廟正式機
// axios.defaults.baseURL = "https://test-api-space-system.nknu.edu.tw"; // 空間系統 demo 機
// axios.defaults.baseURL = "https://test-api-inventory-system.nknu.edu.tw"; // 進銷存訂單管理系統 demo 機
// axios.defaults.baseURL = "https://test-api-crm-system.nknu.edu.tw"; // CRM文案生成及客服系統 demo 機
// axios.defaults.baseURL = "https://api-space-system.nknu.edu.tw"; // 空間系統正式 demo 機
axios.defaults.baseURL = "https://api-job-fair.nknu.edu.tw"; // 國立高雄師範大學校園就業博覽會 demo 機


// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(
//     <div>
//         <App />
//     </div>
// );
ReactDOM.render(
    <>
        <Demosite />
    </>,
    document.getElementById('root')
);



// const App = () => {
//     const elements = document.querySelectorAll('div[data-component="identity_statistics"]');

//     return (
//         <>
//             {Array.from(elements).map((element) => {
//                 let attributeNames = element.getAttributeNames();
//                 let attributes = attributeNames?.map((name) => {
//                     return {
//                         name: name,
//                         value: element.getAttribute(name) // 獲取每個屬性的值
//                     };
//                 });

//                 return <PackageComponent attributes={attributes} />
//             })}
//         </>
//     )
// }
// const PackageComponent = ({
//     attributes,
//     ...props
// }) => {
//     // let element = document.getElementById("identity_statistics")
//     return ReactDOM.createPortal(
//         <div>
//             {
//                 console.log({ attributes })
//             }
//             <IdentityStatistics
//                 gotoPath={attributes.find((ele) => ele?.name === 'goto_path')?.value}
//                 forJs={true}
//                 gotoMethod="window"
//             />
//         </div>,
//         // ,
//         document.getElementById(attributes.find((ele) => ele?.name === 'id')?.value)
//     );
// }





/* ========================================================================================== */
// // 新的 index.js 
// // index.js (或 main.jsx)
// import React from "react";
// import ReactDOM from "react-dom";
// import axios from "axios";
// import Demosite from './websites/Demosite';
// import { ConfigProvider } from 'antd';
// // 引入新的初始化函式
// import i18n, { initializeI18n } from './websites/i18n'; 
// import './styles/globals.css';


// const API_BASE_URL = 'http://localhost:8082'; // 統一定義 baseURL
// // const API_BASE_URL = "http://172.0.6.2:8082";
// // const API_BASE_URL = "https://api-sungolds.orange-technic.com";
// // const API_BASE_URL = "https://api-pccu.orange-technic.com";
// // const API_BASE_URL = "https://api-chci.orange-technic.com:8106";
// // const API_BASE_URL = "https://api-usr-market.nknu.edu.tw";
// // const API_BASE_URL = "https://api-keytravel.nknu.edu.tw";
// // const API_BASE_URL = "https://api-donate.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-donate.nknu.edu.tw";
// // const API_BASE_URL = "https://api-commercial.orange-technic.com";`
// // const API_BASE_URL = "http://140.127.56.21:8082";
// // const API_BASE_URL = "http://192.168.11.125:8082";
// // const API_BASE_URL = "http://10.0.1.174:8082";
// // const API_BASE_URL = "https://api-afats.orange-technic.com";
// // const API_BASE_URL = "https://api-official.charts.kh.edu.tw";
// // const API_BASE_URL = "http://library.nknu.edu.tw:1661";
// // const API_BASE_URL = "https://api-library.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-ntust.orange-technic.com";
// // const API_BASE_URL = "https://test-api-rocafa.orange-technic.com";
// // const API_BASE_URL = "https://api-rocafa.nknu.edu.tw";
// // const API_BASE_URL = "https://api-rocafa.orange-technic.com";
// // const API_BASE_URL = "https://test-api-rocafa.nknu.edu.tw";
// // const API_BASE_URL = "https://api-yi-cheng-tang.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-yi-cheng-tang.nknu.edu.tw";
// // const API_BASE_URL = "http://localhost:8083";
// // const API_BASE_URL = "https://api-donate.nknu.edu.tw";
// // const API_BASE_URL = "https://api-education.orange-technic.com";
// // const API_BASE_URL = "https://www.orange-technic.com:5021";
// // const API_BASE_URL = "https://www.orange-technic.com:7443";
// // const API_BASE_URL = "https://www.orange-technic.com:7469";
// // const API_BASE_URL = "https://www.orange-technic.com:7497";
// // const API_BASE_URL = "https://www.orange-technic.com:7492";
// // const API_BASE_URL = "https://www.orange-technic.com:7483";
// // const API_BASE_URL = "https://www.orange-technic.com:7501";
// // const API_BASE_URL = "https://www.orange-technic.com:7505";
// // const API_BASE_URL = "https://www.orange-technic.com:7517";
// // const API_BASE_URL = "https://www.orange-technic.com:7522";
// // const API_BASE_URL = "https://www.orange-technic.com:7526";
// // const API_BASE_URL = "https://www.orange-technic.com:7530";
// // const API_BASE_URL = "https://www.orange-technic.com:7534";
// // const API_BASE_URL = "https://test-api-preschool.orange-technic.com";
// // const API_BASE_URL = "https://api-preschool-admin.orange-technic.com";
// // const API_BASE_URL = "https://preschool-admin.orange-technic.com:6454";
// // const API_BASE_URL = "https://demosite-preschool-admin.orange-technic.com:6454";
// // const API_BASE_URL = "https://yuankuan.orange-technic.com:8101";
// // const API_BASE_URL = "https://api-hecheng.orange-technic.com";
// // const API_BASE_URL = "https://api-learningmath.nknu.edu.tw";
// // const API_BASE_URL = "https://api-chung-hwa.nknu.edu.tw";
// // const API_BASE_URL = "https://api-pilot.orange-technic.com";
// // const API_BASE_URL = "https://libappapi.pccu.edu.tw";
// // const API_BASE_URL = "https://api-iteach.nknu.edu.tw";
// // const API_BASE_URL = "https://api-mj.orange-technic.com";
// // const API_BASE_URL = "https://api-empathy.orange-technic.com";
// // const API_BASE_URL = "https://api-peace-pcc.nknu.edu.tw";
// // const API_BASE_URL = "https://api-hakka_culture_exam.orange-technic.com";
// // const API_BASE_URL = "https://test-api-hakka_culture_exam.orange-technic.com";
// // const API_BASE_URL = "https://test-api-chung-hwa.orange-technic.com";
// // const API_BASE_URL = "https://test-api-mj.orange-technic.com";
// // const API_BASE_URL = "https://test-api-mercyenglishcenter.orange-technic.com";
// // const API_BASE_URL = "https://beta-api-mercyenglishcenter.orange-technic.com";
// // const API_BASE_URL = "https://test-api-learningmath.orange-technic.com";
// // const API_BASE_URL = "https://api-usr-market.nknu.edu.tw";
// // const API_BASE_URL = "https://api-question-bank.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-taiwan-gist-admin.nknu.edu.tw";
// // const API_BASE_URL = "https://api-yi-cheng-tang.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-reservation-library.nknu.edu.tw";
// // const API_BASE_URL = "https://api-queue-management-admin.nknu.edu.tw";
// // const API_BASE_URL = "https://heyu-inventory-api.orange-technic.com"; // 和裕糧食行正式機
// // const API_BASE_URL = "https://test-heyu-inventory-api.orange-technic.com"; // 和裕糧食行測試機
// // const API_BASE_URL = "https://api-rocafa-test-iread-library.nknu.edu.tw"; // 空軍官校測試機
// // const API_BASE_URL = "https://aio-api-ai.nknu.edu.tw"; // NKNU AIO AI平台
// // const API_BASE_URL = "https://api-afats.nknu.edu.tw"; // 航空技術學院圖書自動化正式機
// // const API_BASE_URL = "https://test-api-afats.nknu.edu.tw"; // 航空技術學院圖書自動化測試機
// // const API_BASE_URL = "https://test-api-library.nknu.edu.tw"; // NKNU圖書自動化測試機
// // const API_BASE_URL = "https://api-tiande.nknu.edu.tw"; // 天德教正式機
// // const API_BASE_URL = "https://api-lingxuan.nknu.edu.tw"; // 三教正式機
// // const API_BASE_URL = "https://api-fengshan-zhennangong.nknu.edu.tw"; // 鳳山鎮南宮仙公廟正式機
// // const API_BASE_URL = "https://test-api-space-system.nknu.edu.tw"; // 空間系統 demo 機
// // const API_BASE_URL = "https://test-api-inventory-system.nknu.edu.tw"; // 進銷存訂單管理系統 demo 機
// // const API_BASE_URL = "https://test-api-crm-system.nknu.edu.tw"; // CRM文案生成及客服系統 demo 機
// // const API_BASE_URL = "https://api-space-system.nknu.edu.tw"; // 空間系統正式 demo 機
// // const API_BASE_URL = "https://api-tiangong.nknu.edu.tw"; // 天公廟正式機
// // const API_BASE_URL = "https://daya-api-ai.nknu.edu.tw"; // 達亞正式機
// // const API_BASE_URL = "https://test-api-project-system.nknu.edu.tw"; // 專案管理系統測試 demo 機
// // const API_BASE_URL = "https://api-project-system.nknu.edu.tw"; // 專案管理系統正式 demo 機



// // 渲染應用程式內容的組件
// const AppContent = () => (
//     <ConfigProvider
//         theme={{
//             token: {
//                 colorPrimary: '#fa8c16',
//                 fontSize: 16
//             },
//         }}>
//         <div>
//             {/* Demosite 不再需要 Promise 等待邏輯 */}
//             <Demosite 
//                 baseURL={API_BASE_URL}
//             />
//         </div>
//     </ConfigProvider>
// );

// const rootElement = document.getElementById("root");

// // --- 啟動函式 ---
// async function bootstrapApp() {
    
//     // 1. 設定 baseURL (這是您只希望在 index.js 中做的事情)
//     axios.defaults.baseURL = API_BASE_URL; 
    
//     // 2. 渲染 Loading 畫面 (可選)
//     ReactDOM.render(
//         <div style={{ padding: '50px', textAlign: 'center', fontSize: '20px' }}>
//             啟動中，載入翻譯中...
//         </div>,
//         rootElement
//     );
    
//     try {
//         // 3. 呼叫 i18n 初始化函式 (此時 baseURL 已設定)
//         await initializeI18n(); 
        
//         // 4. i18n 初始化完成後，渲染完整應用程式
//         ReactDOM.render(
//             <AppContent />,
//             rootElement
//         );
//     } catch (e) {
//         console.error("應用程式啟動失敗 (i18n錯誤):", e);
//         ReactDOM.render(
//             <div>應用程式載入錯誤。</div>,
//             rootElement
//         );
//     }
// }

// // 執行應用程式啟動
// bootstrapApp();
/* ========================================================================================== */





// /* ========================================================================================== */
// // index.js (或 main.jsx)
// import React from "react";
// import ReactDOM from "react-dom";
// import axios from "axios";
// import Demosite from './websites/Demosite';
// import { ConfigProvider } from 'antd';
// // 引入新的初始化函式
// import i18n, { initializeI18n } from './websites/i18n'; 
// import './styles/globals.css';

// const API_BASE_URL = 'http://localhost:8082'; // 統一定義 baseURL

// // const API_BASE_URL = "https://api-tiande.nknu.edu.tw/";//天德正式機

// // API_BASE_URL = "https://test-api-space-system.nknu.edu.tw";//空間
// // API_BASE_URL = "https://test-api-inventory-system.nknu.edu.tw";//進銷存
// // API_BASE_URL = "https://test-api-crm-system.nknu.edu.tw";//CRM
// // const API_BASE_URL = "https://test-api-project-system.nknu.edu.tw";//專案管理
// // API_BASE_URL = "https://api-space-system.nknu.edu.tw";
// // API_BASE_URL = "https://api-poc.nknu.edu.tw";
// // API_BASE_URL = "http://172.0.4.11:7449";
// // API_BASE_URL = "http://172.0.4.41:8082";
// // API_BASE_URL = "https://www.orange-technic.com:7459";
// // API_BASE_URL = "https://www.orange-technic.com:7453";//商城測試
// // API_BASE_URL = "https://www.orange-technic.com:7443";//教育測試
// // API_BASE_URL = "https://www.orange-technic.com:7463";//雙語測試
// // API_BASE_URL = "https://www.orange-technic.com:7469";//洰晟測試
// // API_BASE_URL = "https://api-commercial.orange-technic.com:7469";
// // API_BASE_URL = "https://api-commercial.orange-technic.com";//洰晟正式
// // API_BASE_URL = "https://iteach.orange-technic.com:6444";//雙語正式
// // API_BASE_URL = "https://api-commercial.orange-technic.com:7459";
// // API_BASE_URL = "https://api-education.orange-technic.com";//教育正式
// // API_BASE_URL = "https://api-keytravel.nknu.edu.tw";//EMI學校正式
// // API_BASE_URL = "https://api-learningmath.nknu.edu.tw";//數學系學校正式
// // API_BASE_URL = "https://api-usr-market.nknu.edu.tw";//USR學校正式
// // API_BASE_URL = "https://api-chung-hwa.nknu.edu.tw";//中華藝校正式


// // const API_BASE_URL = "https://api-sungolds.orange-technic.com";
// // const API_BASE_URL = "https://api-pccu.orange-technic.com";
// // const API_BASE_URL = "https://api-chci.orange-technic.com:8106";
// // const API_BASE_URL = "https://api-usr-market.nknu.edu.tw";
// // const API_BASE_URL = "https://api-keytravel.nknu.edu.tw";
// // const API_BASE_URL = "https://api-donate.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-donate.nknu.edu.tw";
// // const API_BASE_URL = "https://api-commercial.orange-technic.com";`
// // const API_BASE_URL = "http://140.127.56.21:8082";
// // const API_BASE_URL = "http://192.168.11.125:8082";
// // const API_BASE_URL = "http://10.0.1.174:8082";
// // const API_BASE_URL = "https://api-afats.orange-technic.com";
// // const API_BASE_URL = "https://api-official.charts.kh.edu.tw";
// // const API_BASE_URL = "http://library.nknu.edu.tw:1661";
// // const API_BASE_URL = "https://api-library.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-ntust.orange-technic.com";
// // const API_BASE_URL = "https://test-api-rocafa.orange-technic.com";
// // const API_BASE_URL = "https://api-rocafa.nknu.edu.tw";
// // const API_BASE_URL = "https://api-rocafa.orange-technic.com";
// // const API_BASE_URL = "https://test-api-rocafa.nknu.edu.tw";
// // const API_BASE_URL = "https://api-yi-cheng-tang.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-yi-cheng-tang.nknu.edu.tw";
// // const API_BASE_URL = "http://localhost:8083";
// // const API_BASE_URL = "https://api-donate.nknu.edu.tw";
// // const API_BASE_URL = "https://api-education.orange-technic.com";
// // const API_BASE_URL = "https://www.orange-technic.com:5021";
// // const API_BASE_URL = "https://www.orange-technic.com:7443";
// // const API_BASE_URL = "https://www.orange-technic.com:7469";
// // const API_BASE_URL = "https://www.orange-technic.com:7497";
// // const API_BASE_URL = "https://www.orange-technic.com:7492";
// // const API_BASE_URL = "https://www.orange-technic.com:7483";
// // const API_BASE_URL = "https://www.orange-technic.com:7501";
// // const API_BASE_URL = "https://www.orange-technic.com:7505";
// // const API_BASE_URL = "https://www.orange-technic.com:7517";
// // const API_BASE_URL = "https://www.orange-technic.com:7522";
// // const API_BASE_URL = "https://www.orange-technic.com:7526";
// // const API_BASE_URL = "https://www.orange-technic.com:7530";
// // const API_BASE_URL = "https://www.orange-technic.com:7534";
// // const API_BASE_URL = "https://test-api-preschool.orange-technic.com";
// // const API_BASE_URL = "https://api-preschool-admin.orange-technic.com";
// // const API_BASE_URL = "https://preschool-admin.orange-technic.com:6454";
// // const API_BASE_URL = "https://demosite-preschool-admin.orange-technic.com:6454";
// // const API_BASE_URL = "https://yuankuan.orange-technic.com:8101";
// // const API_BASE_URL = "https://api-hecheng.orange-technic.com";
// // const API_BASE_URL = "https://api-learningmath.nknu.edu.tw";
// // const API_BASE_URL = "https://api-chung-hwa.nknu.edu.tw";
// // const API_BASE_URL = "https://api-pilot.orange-technic.com";
// // const API_BASE_URL = "https://libappapi.pccu.edu.tw";
// // const API_BASE_URL = "https://api-iteach.nknu.edu.tw";
// // const API_BASE_URL = "https://api-mj.orange-technic.com";
// // const API_BASE_URL = "https://api-empathy.orange-technic.com";
// // const API_BASE_URL = "https://api-peace-pcc.nknu.edu.tw";
// // const API_BASE_URL = "https://api-hakka_culture_exam.orange-technic.com";
// // const API_BASE_URL = "https://test-api-hakka_culture_exam.orange-technic.com";
// // const API_BASE_URL = "https://test-api-chung-hwa.orange-technic.com";
// // const API_BASE_URL = "https://test-api-mj.orange-technic.com";
// // const API_BASE_URL = "https://test-api-mercyenglishcenter.orange-technic.com";
// // const API_BASE_URL = "https://beta-api-mercyenglishcenter.orange-technic.com";
// // const API_BASE_URL = "https://test-api-learningmath.orange-technic.com";
// // const API_BASE_URL = "https://api-usr-market.nknu.edu.tw";
// // const API_BASE_URL = "https://api-question-bank.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-taiwan-gist-admin.nknu.edu.tw";
// // const API_BASE_URL = "https://api-yi-cheng-tang.nknu.edu.tw";
// // const API_BASE_URL = "https://test-api-reservation-library.nknu.edu.tw";
// // const API_BASE_URL = "https://api-queue-management-admin.nknu.edu.tw";
// // const API_BASE_URL = "https://heyu-inventory-api.orange-technic.com"; // 和裕糧食行正式機
// // const API_BASE_URL = "https://test-heyu-inventory-api.orange-technic.com"; // 和裕糧食行測試機
// // const API_BASE_URL = "https://api-rocafa-test-iread-library.nknu.edu.tw"; // 空軍官校測試機
// // const API_BASE_URL = "https://aio-api-ai.nknu.edu.tw"; // NKNU AIO AI平台
// // const API_BASE_URL = "https://api-afats.nknu.edu.tw"; // 航空技術學院圖書自動化正式機
// // const API_BASE_URL = "https://test-api-afats.nknu.edu.tw"; // 航空技術學院圖書自動化測試機
// // const API_BASE_URL = "https://test-api-library.nknu.edu.tw"; // NKNU圖書自動化測試機
// // const API_BASE_URL = "https://api-tiande.nknu.edu.tw"; // 天德教正式機
// // const API_BASE_URL = "https://api-lingxuan.nknu.edu.tw"; // 三教正式機
// // const API_BASE_URL = "https://api-fengshan-zhennangong.nknu.edu.tw"; // 鳳山鎮南宮仙公廟正式機
// // const API_BASE_URL = "https://test-api-space-system.nknu.edu.tw"; // 空間系統 demo 機
// // const API_BASE_URL = "https://test-api-inventory-system.nknu.edu.tw"; // 進銷存訂單管理系統 demo 機
// // const API_BASE_URL = "https://test-api-crm-system.nknu.edu.tw"; // CRM文案生成及客服系統 demo 機
// // const API_BASE_URL = "https://api-space-system.nknu.edu.tw"; // 空間系統正式 demo 機
// // const API_BASE_URL = "https://api-tiangong.nknu.edu.tw"; // 天公廟正式機
// // const API_BASE_URL = "https://daya-api-ai.nknu.edu.tw"; // 達亞正式機
// // const API_BASE_URL = "https://test-api-project-system.nknu.edu.tw"; // 專案管理系統測試 demo 機
// // const API_BASE_URL = "https://api-project-system.nknu.edu.tw"; // 專案管理系統正式 demo 機
// // const API_BASE_URL = "https://api-inventory-system.nknu.edu.tw"; // 進銷存訂單管理系統正式 demo 機
// // const API_BASE_URL = "https://api-crm-system.nknu.edu.tw"; // CRM文案生成及客服系統正式 demo 機
// // const API_BASE_URL = "https://test-api-archive-system.nknu.edu.tw"; // 數位典藏經文管理系統測試 demo 機
// // const API_BASE_URL = "https://api-iread-library.nknu.edu.tw"; // 圖書自動化系統正式 demo 機




// // 渲染應用程式內容的組件
// const AppContent = () => (
//     <ConfigProvider
//         theme={{
//             token: {
//                 colorPrimary: '#fa8c16',
//                 fontSize: 16
//             },
//         }}>
//         <div>
//             {/* Demosite 不再需要 Promise 等待邏輯 */}
//             <Demosite 
//                 baseURL={API_BASE_URL}
//             />
//         </div>
//     </ConfigProvider>
// );

// const rootElement = document.getElementById("root");

// // --- 啟動函式 ---
// async function bootstrapApp() {
    
//     // 1. 設定 baseURL (這是您只希望在 index.js 中做的事情)
//     axios.defaults.baseURL = API_BASE_URL; 

//     // 2. 渲染 Loading 畫面 (可選)
//     const spinnerStyle = `
//         @keyframes spin {
//             from { transform: rotate(0deg); }
//             to { transform: rotate(360deg); }
//         }
//         .loading-spinner {
//             display: inline-block;
//             width: 50px;
//             height: 50px;
//             border: 5px solid rgba(255, 255, 255, 0.3);
//             border-top: 5px solid #fa8c16;
//             border-radius: 50%;
//             animation: spin 1s linear infinite;
//         }
//     `;
//     ReactDOM.render(
//         <>
//             <style>{spinnerStyle}</style>
//             <div style={{
//                 position: 'fixed',
//                 top: 0,
//                 left: 0,
//                 width: '100%',
//                 height: '100%',
//                 background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 alignItems: 'center',
//                 justifyContent: 'center',
//                 gap: '20px',
//                 fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
//             }}>
//                 <div className="loading-spinner"></div>
//                 <div style={{
//                     fontSize: '24px',
//                     fontWeight: '500',
//                     color: 'white',
//                     letterSpacing: '1px'
//                 }}>
//                     系統啟動中...
//                 </div>
//                 <div style={{
//                     fontSize: '14px',
//                     color: 'rgba(255, 255, 255, 0.8)',
//                     marginTop: '10px'
//                 }}>
//                     初始化數據中，請稍候
//                 </div>
//             </div>
//         </>,
//         rootElement
//     );
    
//     try {
//         // 3. 呼叫 i18n 初始化函式 (此時 baseURL 已設定)
//         await initializeI18n(); 
        
//         // 4. i18n 初始化完成後，渲染完整應用程式
//         ReactDOM.render(
//             <AppContent />,
//             rootElement
//         );
//     } catch (e) {
//         console.error("應用程式啟動失敗 (i18n錯誤):", e);
//         ReactDOM.render(
//             <div>應用程式載入錯誤。</div>,
//             rootElement
//         );
//     }
// }

// // 執行應用程式啟動
// bootstrapApp();
// /* ========================================================================================== */
